import styled from "styled-components";
import { variantToColour } from "../../helpers/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ThemedIcon = styled(FontAwesomeIcon)`
    color: ${props => variantToColour({ theme: props.theme, variant: props.variant })};
`;

export default ThemedIcon;